import MenuItem from "../MenuItem";
import { MenuContainer } from "./styled";
import dashboard_icon from "../../../../assets/icons/dashboard.svg";
import reports_icon from "../../../../assets/icons/reports.svg";
import exit_icon from "../../../../assets/icons/exit.svg";
import notifications_icon from "../../../../assets/icons/notifications.svg";
import connections_icon from "../../../../assets/icons/connections.svg";
import degradation_icon from "../../../../assets/icons/degradation.svg";
import scripts_icon from "../../../../assets/icons/scripts.svg";
import { connect } from "react-redux";
import {
  mapDispatchToProps,
  mapStateToProps,
} from "../../../../utils/storeUtils";
import { useState } from "react";
import ExitModal from "../../Modals/ExitModal";

const Menu = ({
  menu,
  setShowDashboard,
  setShowNotifications,
  setShowReports,
  setShowDegradations,
  setShowConnections,
  setShowScripts,
}) => {
  const [showExit, setShowExit] = useState(false);
  return (
    <MenuContainer>
      {menu.type === "MAP-PAGE" && (
        <>
          <MenuItem
            title={"Dashboard"}
            icon={dashboard_icon}
            activateMenuItem={menu.showDashboard}
            onClick={setShowDashboard}
          />
          <MenuItem
            title={"Relatórios"}
            icon={reports_icon}
            activateMenuItem={menu.showReports}
            onClick={setShowReports}
          />
          <MenuItem
            title={"Notificações"}
            icon={notifications_icon}
            activateMenuItem={menu.showNotifications}
            onClick={setShowNotifications}
          />
        </>
      )}

      {menu.type === "ASSET-PAGE" && (
        <>
          <MenuItem
            title={"Dashboard"}
            icon={dashboard_icon}
            activateMenuItem={menu.showDashboard}
            onClick={setShowDashboard}
          />
          <MenuItem
            title={""}
            icon={degradation_icon}
            activateMenuItem={menu.showDegradations}
            onClick={setShowDegradations}
          />
          <MenuItem
            title={"Relatórios"}
            icon={reports_icon}
            activateMenuItem={menu.showReports}
            onClick={setShowReports}
          />
          <MenuItem
            title={""}
            icon={connections_icon}
            activateMenuItem={menu.showConnections}
            onClick={setShowConnections}
          />
          <MenuItem
            title={""}
            icon={scripts_icon}
            activateMenuItem={menu.showScripts}
            onClick={() => {
              const printWindow = window.open("/print/1", "_blank");

              if (printWindow) {
                // precisa ser no printWindow, não no window principal
                const handleReady = () => {
                  printWindow.focus();
                  printWindow.print();
                  printWindow.close();
                  printWindow.removeEventListener("report-ready", handleReady);
                };

                printWindow.addEventListener("report-ready", handleReady);
              }
            }}
          />
        </>
      )}

      {menu.type === "SECTION-PAGE" && (
        <>
          <MenuItem
            title={"Dashboard"}
            icon={dashboard_icon}
            activateMenuItem={menu.showDashboard}
            onClick={setShowDashboard}
          />
          <MenuItem
            title={"Relatórios"}
            icon={reports_icon}
            activateMenuItem={menu.showReports}
            onClick={setShowReports}
          />
        </>
      )}

    </MenuContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
